import React from 'react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import Seo from './Seo';
import { servicesPageJsonLd } from '../seo/structuredData';
import { useI18n } from '../i18n/I18nContext';
import './Leistungen.css';

const deRooms = [
  {
    title: '1:1 Spiegel-Arbeit',
    subtitle: 'Für Entscheiderinnen und Entscheider vor und in entscheidenden Momenten',
    body: 'Eine Verhandlung, die über Jahre entscheidet. Ein Team, das Ihre Führung nicht trägt. Ein Rollenwechsel, der mehr verlangt als Erfahrung. In der Einzelarbeit erkennen Sie, welche Muster Sie tragen und welche Sie behindern, und bereiten den entscheidenden Schritt präzise vor.',
    occasions: [
      'Verhandlungen und Gespräche mit hohem Einsatz',
      'Führung gegen Widerstand',
      'Rollenwechsel, Nachfolge und neue Verantwortung',
    ],
    format: 'Online oder in Präsenz. Der Umfang richtet sich nach dem Anliegen, nicht nach der Uhr.',
  },
  {
    title: 'Spiegelkraft für Systeme',
    subtitle: 'Für Führungskreise, Projektteams und Familienunternehmen',
    body: 'Wenn ein System sich festgefahren hat, liegt das Problem selten bei einer einzelnen Person. In Workshops und Mediationen wird sichtbar, wie Ihr System tatsächlich funktioniert und wo es sich bewegen lässt.',
    occasions: [
      'Konflikte im Führungskreis oder in der Projektleitung, als Mediation',
      'Macht, Rollen und Erwartungen im Familienunternehmen',
      'Verhandlungsführung sowie Feedback- und Konfliktkultur, als Workshop',
    ],
    format: 'Halb- oder ganztägig, inhouse oder an einem neutralen Ort.',
  },
  {
    title: 'Spiegel für Wirkung und Haltung',
    subtitle: 'Für Führungskräfte und Talente auf dem Weg ins Top-Management',
    body: 'Auf oberster Ebene entscheidet selten die fachliche Leistung allein, sondern Präsenz und informelle Macht. In der Einzelarbeit erkennen Sie, wie Sie dort wirken, wo die Grenzen verlaufen, die Sie halten sollten, und was es braucht, um dort zu bestehen.',
    occasions: [
      'Präsenz und Positionierung vor Vorstand und Top-Management',
      'Informelle Macht und ungeschriebene Spielregeln',
      'Loyalitätskonflikte zwischen Zielvorgabe, Compliance und Haltung',
    ],
    format: 'Online oder in Präsenz. Auf Wunsch als Programm für mehrere Führungskräfte eines Unternehmens, stets in Einzelarbeit.',
  },
];

const serviceImages = [
  '/img/michaela_leistungen_coaching.png',
  '/img/michaela_spiegelkraft.jpg',
  '/img/unterschrift.jpeg',
];

const serviceIds = ['spiegel-arbeit', 'systeme', 'zirkel'];
const serviceLayouts = ['leistungen-service-layout--top', 'leistungen-service-layout--center', ''];

function Leistungen() {
  const { lang, copy } = useI18n();
  const rooms = lang === 'en' ? copy.rooms : deRooms;
  const talks = lang === 'en' ? '/en/speaking' : '/vortraege';

  return (
    <div className="leistungen-page">
      <Seo
        page="leistungen"
        jsonLd={servicesPageJsonLd(lang)}
      />
      <Header />
      
      <div className="leistungen-hero-section">
        <div className="leistungen-hero-content">
          <p className="leistungen-hero-label">{copy.services.label}</p>
          <h1 className="leistungen-hero-title">
            {copy.services.title}
          </h1>
          <p className="leistungen-hero-positioning">
            {copy.services.intro}
          </p>
        </div>
      </div>

      <div className="leistungen-main-content">

        {rooms.map((room, index) => (
        <section className="leistungen-service-section" id={serviceIds[index]} key={serviceIds[index]}>
          <div className={`leistungen-service-layout ${serviceLayouts[index]}`.trim()}>
            <div className="leistungen-service-image">
              <img 
                src={serviceImages[index]} 
                alt={copy.services.alts[index]} 
                className="leistungen-image"
              />
            </div>
            
            <div className="leistungen-service-text">
              <div className="leistungen-service-header">
                <h2 className="leistungen-service-title mirror-ornament">{room.title}</h2>
                <p className="leistungen-service-subtitle">{room.subtitle}</p>
                {room.note ? <p className="leistungen-service-note">{room.note}</p> : null}
              </div>
              
              <div className="leistungen-service-content">
                <p className="leistungen-service-description">{room.body}</p>
                {room.occasions ? (
                  <ul className="leistungen-topics-list">
                    {room.occasions.map((item) => <li key={item}>{item}</li>)}
                  </ul>
                ) : null}
                {room.format ? (
                  <p className="leistungen-format">
                    <strong>{copy.home.formatLabel}</strong> {room.format}
                  </p>
                ) : null}
              </div>
            </div>
          </div>
        </section>
        ))}

        <p className="leistungen-vortraege-link">
          <Link to={talks}>{copy.services.talks}</Link>
        </p>

      </div>

      <Footer />
    </div>
  );
}

export default Leistungen;
